// extracted by mini-css-extract-plugin
export default {"title_box":"index_title_box_mTUmj","title":"index_title_WcWN5","title1":"index_title1_szaVB","current":"index_current_rTzM2"};